import { render, staticRenderFns } from "./record.vue?vue&type=template&id=136b3a72&scoped=true"
import script from "./record.vue?vue&type=script&lang=js"
export * from "./record.vue?vue&type=script&lang=js"
import style0 from "./record.vue?vue&type=style&index=0&id=136b3a72&scoped=true&lang=scss"
import style1 from "./record.vue?vue&type=style&index=1&id=136b3a72&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "136b3a72",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('136b3a72')) {
      api.createRecord('136b3a72', component.options)
    } else {
      api.reload('136b3a72', component.options)
    }
    module.hot.accept("./record.vue?vue&type=template&id=136b3a72&scoped=true", function () {
      api.rerender('136b3a72', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/hr/archives/components/record.vue"
export default component.exports